const useFormativeAttachment = ({
  isFormativeCuratedConnection,
  attachments,
}) => {
  let formativeAttachmentId;
  const formativeAttachment = attachments?.find(
    (attachment) => attachment.content_type === "FORMATIVE",
  );
  const formativeAttachmentStream = formativeAttachment?.subject?.data?.subject;
  if (
    isFormativeCuratedConnection &&
    formativeAttachment &&
    (formativeAttachmentStream === "SCIENCE" ||
      formativeAttachmentStream === "SOCIAL_STUDIES")
  ) {
    formativeAttachmentId = formativeAttachment.id;
  }
  const curatedFormativeCta =
    formativeAttachment && formativeAttachmentId
      ? {
          headline: formativeAttachment.data.link_title,
          body: formativeAttachment.data.link_description,
          url: formativeAttachment.data.url,
        }
      : undefined;

  return {
    formativeAttachmentId,
    curatedFormativeCta,
    formativeAttachmentStream,
  };
};

export default useFormativeAttachment;
